import React, { useState } from 'react';
import styles from './emailVerification.module.scss';
import { ReactComponent as ErrorWarningIcon } from 'v2/icons/error_warning.svg';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from 'v2/models';
import { useMutation } from 'react-query';
import restFactory from 'v2/utils/restFactory';
import { toast } from 'react-toastify';
import { unit } from 'mathjs';
import useEmailVerification from 'v2/hooks/useEmailVerification';
import { useFreeUser } from 'v2/hooks/useFreeUser';

const DISABLED_TIMEOUT = unit('20s').toNumber('ms');

const EmailVerification = () => {
  const user = useSelector((state: RootState) => state.user.user);

  const [actionDisabled, setActionDisabled] = useState(false);
  const emailVerified = user.auth0_email_verified;
  const [isFreeUser] = useFreeUser();

  const { isFetched } = useEmailVerification(emailVerified);

  const { mutate: sendVerificationEmail } = useMutation(
    async () => {
      setActionDisabled(true);
      return await restFactory.post(`/dj/api/v1/strapi_user/verify_email/`, {});
    },
    {
      onSuccess: () => {
        toast.success('Email sent.');
      },
      onError: () => {
        toast.error('Error sending email.');
      },
      onSettled: () => {
        setTimeout(() => {
          setActionDisabled(false);
        }, DISABLED_TIMEOUT);
      },
    }
  );

  return isFreeUser && !emailVerified && isFetched ? (
    <div className="table-container">
      <div className={classNames(styles.emailVerificationContainer)}>
        <ErrorWarningIcon />
        <div>
          <h5>Verify your email address.</h5>
          <p>
            We have sent an email to {user.email}. Click on the link to complete
            the verification process. You might need to check you spam folder.{' '}
            <button
              onClick={() => sendVerificationEmail()}
              disabled={actionDisabled}
            >
              Resend email.
            </button>
          </p>
        </div>
      </div>
    </div>
  ) : null;
};

export default EmailVerification;
